import mutations from './accountRequestMutation';
import actions from './accountRequestAction';
import getters from './accountRequestGetter';

const state = {
  gridData: {},
  accountInfo: {},
  rootGridData: {},
  rootAccountInfo: {},
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/vuex/accountManagement/accountRequest/accountRequestStore.js